"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[561],{

/***/ 31561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ SearchTicketsForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Flex/index.ts + 8 modules
var Flex = __webpack_require__(69029);
// EXTERNAL MODULE: ./components/ui/Icon/index.ts + 3 modules
var Icon = __webpack_require__(37033);
// EXTERNAL MODULE: ./components/ui/Tooltip/index.ts + 2 modules
var Tooltip = __webpack_require__(7082);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
// EXTERNAL MODULE: ./core/env.ts
var env = __webpack_require__(81622);
// EXTERNAL MODULE: ./interfaces/Passenger.ts
var Passenger = __webpack_require__(31448);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-outside-click-handler/index.js
var react_outside_click_handler = __webpack_require__(39834);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./styles/mixins/indent/indent.ts
var indent = __webpack_require__(81);
;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/PassengersSelect/styles.ts


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  width: 210px;\n  height: 50px;\n  border-radius: 12px;\n  position: relative;\n  span {\n    line-height: 1.3;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n  ",
        "\n\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      opacity: 1;\n      visibility: visible;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: calc(100% + 8px);\n  left: -50px;\n  width: 300px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  padding: 16px 16px 0;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  ",
        "\n\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n    left: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  height: 11px;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  border-radius: 8px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  flex-grow: 1;\n  background: none;\n  outline: none;\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 8px;\n  ",
        "\n\n  span {\n    line-height: 1;\n    letter-spacing: -0.8px;\n\n    @media screen and (max-width: 460px) {\n      font-size: 12px;\n    }\n  }\n\n  &:last-child {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 29px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 300;\n  font-family: sans-serif;\n  line-height: 1;\n  pointer-events: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 14px 0;\n  margin-top: 2px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  user-select: none;\n  ",
        " {\n    &:last-child {\n      border: none;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var PassengerSelectButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3ebeb7fc-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.TRANSPARENT;
}, function() {
    return (0,indent/* indent */.W)('padding', {
        top: 0,
        bottom: 0,
        left: 16,
        right: 32
    });
});
var PassengerDropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ebeb7fc-1"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.GRAY;
}, function(param) {
    var isShow = param.isShow;
    return isShow && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var Arrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ebeb7fc-2"
})(_templateObject3());
var TypeSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ebeb7fc-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
});
var TypeSwitcherButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3ebeb7fc-4"
})(_templateObject6(), function(param) {
    var isActive = param.isActive, theme = param.theme;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), theme.palette.core.WHITE);
});
var CounterButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ebeb7fc-5"
})(_templateObject7(), function(param) {
    var disabled = param.disabled;
    return disabled ? 'none' : 'auto';
});
var CounterItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ebeb7fc-6"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
});
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ebeb7fc-7"
})(_templateObject9(), CounterItem);

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/PassengersSelect/component.tsx














function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var PassengerSelectorType;
(function(PassengerSelectorType) {
    PassengerSelectorType[PassengerSelectorType["BASIC"] = 0] = "BASIC";
    PassengerSelectorType[PassengerSelectorType["KID"] = 1] = "KID";
    PassengerSelectorType[PassengerSelectorType["DISABLED"] = 2] = "DISABLED";
})(PassengerSelectorType || (PassengerSelectorType = {}));
var PassengersSelect = function(param1) {
    var passengers = param1.passengers, addPassenger = param1.addPassenger, removePassenger = param1.removePassenger;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var t = (0,useTranslation/* default */.Z)('passengersPicker').t;
    var ref = _slicedToArray((0,useToggle/* default */.Z)(false), 2), isShowDropdown = ref[0], toggleDropdown = ref[1];
    var ref1 = (0,react.useState)(PassengerSelectorType.BASIC), activeType = ref1[0], setActiveType = ref1[1];
    var passengersCounts = (0,react.useMemo)(function() {
        var basic = passengers[Passenger/* PassengerTypes.BASIC_MALE */.L.BASIC_MALE] + passengers[Passenger/* PassengerTypes.BASIC_FEMALE */.L.BASIC_FEMALE];
        var kid = passengers[Passenger/* PassengerTypes.KID */.L.KID] + passengers[Passenger/* PassengerTypes.KID_BABY */.L.KID_BABY];
        var disabled = passengers[Passenger/* PassengerTypes.DISABLED_MALE */.L.DISABLED_MALE] + passengers[Passenger/* PassengerTypes.DISABLED_FEMALE */.L.DISABLED_FEMALE];
        return {
            total: Object.values(passengers).reduce(function(acc, curr) {
                return acc + curr;
            }, 0),
            basic: {
                total: basic,
                male: passengers[Passenger/* PassengerTypes.BASIC_MALE */.L.BASIC_MALE],
                female: passengers[Passenger/* PassengerTypes.BASIC_FEMALE */.L.BASIC_FEMALE]
            },
            kid: {
                total: kid,
                child: passengers[Passenger/* PassengerTypes.KID */.L.KID],
                baby: passengers[Passenger/* PassengerTypes.KID_BABY */.L.KID_BABY]
            },
            disabled: {
                total: disabled,
                male: passengers[Passenger/* PassengerTypes.DISABLED_MALE */.L.DISABLED_MALE],
                female: passengers[Passenger/* PassengerTypes.DISABLED_FEMALE */.L.DISABLED_FEMALE]
            }
        };
    }, [
        passengers
    ]);
    var typeButtons = [
        {
            value: PassengerSelectorType.BASIC,
            label: t('passengerTypeMulti.basic')
        },
        {
            value: PassengerSelectorType.KID,
            label: t('passengerTypeMulti.kid')
        },
        {
            value: PassengerSelectorType.DISABLED,
            label: t('passengerTypeMulti.disabled')
        }, 
    ];
    var getIconColor = function(isDisabled) {
        return theme.palette.core[isDisabled ? 'LIGHT_GRAY' : 'DEEP_GRAY'];
    };
    var getDisabledMinusState = function(count) {
        if (passengersCounts.basic.total + passengersCounts.disabled.total === passengersCounts.kid.baby) return true;
        return count <= 0 || passengersCounts.kid.total >= 1 && passengersCounts.total - passengersCounts.kid.total <= 1;
    };
    var getMinusTooltip = function(count) {
        if (count === 0) return;
        if (passengersCounts.kid.total >= 1 && passengersCounts.total - passengersCounts.kid.total <= 1) return t('tooltip.atLeastOneAdult');
        if (passengersCounts.basic.total + passengersCounts.disabled.total === passengersCounts.kid.baby) return t('tooltip.kid');
    };
    var _obj;
    var forms = (_obj = {}, _defineProperty(_obj, PassengerSelectorType.BASIC, {
        label: t('adultsOverFifteen'),
        counters: [
            {
                label: t('gender.male'),
                sublabel: '',
                type: Passenger/* PassengerTypes.BASIC_MALE */.L.BASIC_MALE,
                value: passengersCounts.basic.male,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: theme.icons.core.PeopleWithHighlight,
                    size: 24,
                    color: "#007AFF"
                }),
                tooltip: {
                    plus: t('tooltip.core', {
                        value: env/* MAX_TICKETS_TO_BUY */.VL
                    }),
                    minus: getMinusTooltip(passengersCounts.basic.male)
                },
                disabled: {
                    plus: false,
                    minus: getDisabledMinusState(passengersCounts.basic.male)
                }
            },
            {
                label: t('gender.female'),
                sublabel: '',
                type: Passenger/* PassengerTypes.BASIC_FEMALE */.L.BASIC_FEMALE,
                value: passengersCounts.basic.female,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: theme.icons.core.PeopleWithHighlight,
                    size: 24,
                    color: theme.palette.secondary.MAIN
                }),
                tooltip: {
                    plus: t('tooltip.core', {
                        value: env/* MAX_TICKETS_TO_BUY */.VL
                    }),
                    minus: getMinusTooltip(passengersCounts.basic.female)
                },
                disabled: {
                    plus: false,
                    minus: getDisabledMinusState(passengersCounts.basic.female)
                }
            }, 
        ]
    }), _defineProperty(_obj, PassengerSelectorType.KID, {
        label: '',
        counters: [
            {
                label: t('kidType.childTitle'),
                sublabel: t('kidType.childLabel'),
                type: Passenger/* PassengerTypes.KID */.L.KID,
                value: passengersCounts.kid.child,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: theme.icons.core.ChildWithHighlight,
                    size: 24,
                    color: theme.palette.secondary.MAIN
                }),
                tooltip: {
                    plus: t('tooltip.core', {
                        value: env/* MAX_TICKETS_TO_BUY */.VL
                    }),
                    minus: ''
                },
                disabled: {
                    plus: false,
                    minus: passengersCounts.kid.child <= 0
                }
            },
            {
                label: t('kidType.babyTitle'),
                sublabel: t('kidType.babyLabel'),
                type: Passenger/* PassengerTypes.KID_BABY */.L.KID_BABY,
                value: passengersCounts.kid.baby,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: theme.icons.core.BabyWithHighlight,
                    size: 24,
                    color: theme.palette.secondary.MAIN
                }),
                tooltip: {
                    plus: t('tooltip.kid'),
                    minus: ''
                },
                disabled: {
                    plus: passengersCounts.disabled.total + passengersCounts.basic.total === passengersCounts.kid.baby,
                    minus: passengersCounts.kid.baby <= 0
                }
            }, 
        ]
    }), _defineProperty(_obj, PassengerSelectorType.DISABLED, {
        label: t('passengersWithExtra'),
        counters: [
            {
                label: t('gender.male'),
                sublabel: '',
                type: Passenger/* PassengerTypes.DISABLED_MALE */.L.DISABLED_MALE,
                value: passengersCounts.disabled.male,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: theme.icons.core.PeopleWithHighlight,
                    size: 24,
                    color: "#007AFF"
                }),
                tooltip: {
                    plus: t('tooltip.core', {
                        value: env/* MAX_TICKETS_TO_BUY */.VL
                    }),
                    minus: getMinusTooltip(passengersCounts.disabled.male)
                },
                disabled: {
                    plus: false,
                    minus: getDisabledMinusState(passengersCounts.disabled.male)
                }
            },
            {
                label: t('gender.female'),
                sublabel: '',
                type: Passenger/* PassengerTypes.DISABLED_FEMALE */.L.DISABLED_FEMALE,
                value: passengersCounts.disabled.female,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: theme.icons.core.PeopleWithHighlight,
                    size: 24,
                    color: theme.palette.secondary.MAIN
                }),
                tooltip: {
                    plus: t('tooltip.core', {
                        value: env/* MAX_TICKETS_TO_BUY */.VL
                    }),
                    minus: getMinusTooltip(passengersCounts.disabled.female)
                },
                disabled: {
                    plus: false,
                    minus: getDisabledMinusState(passengersCounts.disabled.female)
                }
            }, 
        ]
    }), _obj);
    var form = forms[activeType];
    var isDisabledPlus = passengersCounts.total >= env/* MAX_TICKETS_TO_BUY */.VL;
    var isDisabledMinus = passengersCounts.total === 1;
    var passengersCountLabel = (0,react.useMemo)(function() {
        if (passengersCounts.total === 1) return null;
        if (passengersCounts.basic.total === passengersCounts.total) return t('basicPlural', {
            count: passengersCounts.total
        });
        if (passengersCounts.kid.total === passengersCounts.total) return t('kidPlural', {
            count: passengersCounts.total
        });
        if (passengersCounts.disabled.total === passengersCounts.total) return t('disabledPlural', {
            count: passengersCounts.total
        });
        var basicStr = passengersCounts.basic.total ? "".concat(passengersCounts.basic.total, " ").concat(t('passengerTypeSingleShort.basic')) : '';
        var kidStr = passengersCounts.kid.total ? "".concat(passengersCounts.kid.total, " ").concat(t('passengerTypeSingleShort.kid')) : '';
        var disabledStr = passengersCounts.disabled.total ? "".concat(passengersCounts.disabled.total, " ").concat(t('passengerTypeSingleShort.disabled')) : '';
        return [
            basicStr,
            kidStr,
            disabledStr
        ].filter(function(str) {
            return Boolean(str);
        }).join(', ');
    }, [
        passengersCounts
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_outside_click_handler["default"], {
        onOutsideClick: function() {
            return toggleDropdown(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PassengerSelectButton, {
                    type: "button",
                    onClick: toggleDropdown,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        container: true,
                        columnGap: 8,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                icon: theme.icons.core.People,
                                color: theme.palette.secondary.MAIN
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                container: true,
                                direction: "column",
                                gap: 2,
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        typography: theme.typography.variants.content.MAIN,
                                        children: t('passengersPlural', {
                                            count: passengersCounts.total
                                        })
                                    }),
                                    passengersCountLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        marginTop: -4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            typography: theme.typography.variants.description.MAIN,
                                            color: theme.palette.text.DEEP_GRAY,
                                            children: passengersCountLabel
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                    size: 11,
                                    icon: theme.icons.core.ArrowShow,
                                    color: theme.palette.core.DEEP_GRAY
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PassengerDropdown, {
                    isShow: isShowDropdown,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeSwitcher, {
                            children: typeButtons.map(function(param) {
                                var label = param.label, value = param.value;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TypeSwitcherButton, {
                                    type: "button",
                                    isActive: value === activeType,
                                    "data-testid": "".concat(value, "-switch"),
                                    onClick: function() {
                                        return setActiveType(value);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        typography: theme.typography.variants.content.MAIN,
                                        children: label
                                    })
                                }, value);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            marginTop: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                typography: theme.typography.variants.description.MAIN,
                                children: form.label
                            })
                        }),
                        form.counters.map(function(counter) {
                            var withWrapper = function(content, type) {
                                var tooltipContent;
                                if ((isDisabledPlus || counter.disabled.plus) && type === 'plus') tooltipContent = counter.tooltip.plus;
                                else if ((isDisabledMinus || counter.disabled.minus) && type === 'minus') tooltipContent = counter.tooltip.minus;
                                if (!tooltipContent) return content;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                    placement: "bottom",
                                    trigger: "hover",
                                    content: tooltipContent,
                                    offset: [
                                        -20,
                                        20
                                    ],
                                    width: 231,
                                    children: content
                                }, counter.label));
                            };
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CounterItem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    container: true,
                                    alignItems: "center",
                                    justify: "space-between",
                                    gap: 18,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                            item: true,
                                            basis: 24,
                                            grow: 0,
                                            children: counter.Icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            item: true,
                                            grow: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    children: counter.label
                                                }),
                                                counter.sublabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        typography: theme.typography.variants.description.MAIN,
                                                        color: theme.palette.core.DEEP_GRAY,
                                                        children: counter.sublabel
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            container: true,
                                            alignItems: "center",
                                            columnGap: 8,
                                            children: [
                                                withWrapper(/*#__PURE__*/ (0,jsx_runtime.jsx)(CounterButton, {
                                                    disabled: isDisabledMinus || counter.disabled.minus,
                                                    onClick: function() {
                                                        return removePassenger(counter.type);
                                                    },
                                                    "data-testid": "decrement-btn",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                        icon: theme.icons.counter.Remove,
                                                        size: 16,
                                                        color: getIconColor(isDisabledMinus || counter.disabled.minus)
                                                    })
                                                }), 'minus'),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                    paddingTop: 4,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        as: "p",
                                                        children: counter.value
                                                    })
                                                }),
                                                withWrapper(/*#__PURE__*/ (0,jsx_runtime.jsx)(CounterButton, {
                                                    disabled: counter.disabled.plus || isDisabledPlus,
                                                    onClick: function() {
                                                        return addPassenger(counter.type);
                                                    },
                                                    "data-testid": "increment-btn",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                        icon: theme.icons.counter.Add,
                                                        size: 16,
                                                        color: getIconColor(isDisabledPlus || counter.disabled.plus)
                                                    })
                                                }), 'plus')
                                            ]
                                        })
                                    ]
                                })
                            }, counter.label));
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/PassengersSelect/index.ts


// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 6 modules
var parse = __webpack_require__(24002);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/compareDesc/index.js
var compareDesc = __webpack_require__(17445);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addYears/index.js
var addYears = __webpack_require__(21593);
;// CONCATENATED MODULE: ./store/features/ticketsSearch/utilitites/getInitialSearchValues/getInitialSearchValues.ts


function getInitialSearchValues_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            getInitialSearchValues_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _obj;
var defaultPassengers = (_obj = {}, getInitialSearchValues_defineProperty(_obj, Passenger/* PassengerTypes.BASIC_MALE */.L.BASIC_MALE, 1), getInitialSearchValues_defineProperty(_obj, Passenger/* PassengerTypes.BASIC_FEMALE */.L.BASIC_FEMALE, 0), getInitialSearchValues_defineProperty(_obj, Passenger/* PassengerTypes.KID */.L.KID, 0), getInitialSearchValues_defineProperty(_obj, Passenger/* PassengerTypes.KID_BABY */.L.KID_BABY, 0), getInitialSearchValues_defineProperty(_obj, Passenger/* PassengerTypes.DISABLED_MALE */.L.DISABLED_MALE, 0), getInitialSearchValues_defineProperty(_obj, Passenger/* PassengerTypes.DISABLED_FEMALE */.L.DISABLED_FEMALE, 0), _obj);
var getOutboundDate = function(outbound) {
    var outboundDate = typeof outbound === 'string' ? (0,parse["default"])(outbound, 'ddMM', new Date()) : new Date();
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    if ((0,compareDesc/* default */.Z)(outboundDate, today) > 0) outboundDate = (0,addYears["default"])(outboundDate, 1);
    return outboundDate.toISOString();
};
var getInboundDate = function(inbound, outboundDate) {
    var inboundDate = typeof inbound === 'string' ? (0,parse["default"])(inbound, 'ddMM', new Date()) : null;
    if (inboundDate && outboundDate && Boolean((0,compareDesc/* default */.Z)(inboundDate, new Date(outboundDate)) + 1)) {
        inboundDate = (0,addYears["default"])(inboundDate, 1);
    }
    return (inboundDate === null || inboundDate === void 0 ? void 0 : inboundDate.toISOString()) || null;
};
var getInitialSearchValues = function(param, stations) {
    var originShortCode = param.origin, destinationShortCode = param.destination, outbound = param.outbound, inbound = param.inbound, passengersStr = param.passengers;
    var origin = stations.find(function(city) {
        return city.shortCode === originShortCode;
    }) || stations[0];
    var destination = stations.find(function(city) {
        return city.shortCode === destinationShortCode;
    }) || stations[1];
    var outboundDate = getOutboundDate(outbound);
    var inboundDate = getInboundDate(inbound, outboundDate);
    var passengers = typeof passengersStr !== 'string' ? defaultPassengers : passengersStr.split(',').reduce(function(acc, passenger) {
        var type = passenger.replace(/[0-9]/g, '');
        var value = passenger.replace(/[A-Za-z_]/g, '');
        return _objectSpread({}, acc, getInitialSearchValues_defineProperty({}, type, Number(value)));
    }, _objectSpread({}, defaultPassengers, getInitialSearchValues_defineProperty({}, Passenger/* PassengerTypes.BASIC_MALE */.L.BASIC_MALE, 0)));
    return {
        isSingle: !inboundDate,
        origin: origin,
        destination: destination,
        outboundDate: outboundDate,
        inboundDate: inboundDate,
        passengers: passengers
    };
};

;// CONCATENATED MODULE: ./store/features/ticketsSearch/utilitites/getInitialSearchValues/index.ts


// EXTERNAL MODULE: ./store/hooks.ts
var hooks = __webpack_require__(1361);
// EXTERNAL MODULE: ./store/selectors/getEntities/selector.ts
var selector = __webpack_require__(62479);
// EXTERNAL MODULE: ./analytics/push/push.ts
var push = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./interfaces/GoogleAnalytics.ts
var GoogleAnalytics = __webpack_require__(74149);
;// CONCATENATED MODULE: ./analytics/events/ticketsSearch/event.ts




function event_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function event_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            event_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ticketsSearchEvent = function(stations, searchParams) {
    var origin = searchParams.origin, destination = searchParams.destination, outboundDate = searchParams.outboundDate, inboundDate = searchParams.inboundDate, passengers = searchParams.passengers;
    var stationsMap = stations.reduce(function(prevVal, currVal) {
        return event_objectSpread({}, prevVal, event_defineProperty({}, currVal.uic, currVal));
    }, {});
    var adultPassengers = passengers[Passenger/* PassengerTypes.BASIC_MALE */.L.BASIC_MALE] + passengers[Passenger/* PassengerTypes.BASIC_FEMALE */.L.BASIC_FEMALE];
    var kidPassengers = passengers[Passenger/* PassengerTypes.KID */.L.KID] + passengers[Passenger/* PassengerTypes.KID_BABY */.L.KID_BABY];
    var preferentialPassengers = passengers[Passenger/* PassengerTypes.DISABLED_MALE */.L.DISABLED_MALE] + passengers[Passenger/* PassengerTypes.DISABLED_FEMALE */.L.DISABLED_FEMALE];
    (0,push/* pushEvent */.A)({
        event: GoogleAnalytics/* AnalyticsEventType.TICKET_SEARCH_RESULT */.n.TICKET_SEARCH_RESULT,
        eventProperties: {
            eventCategory: 'reference data search',
            eventAction: 'search start',
            eventLabel: 'search success'
        },
        searchProperties: {
            searchDestinationName: stationsMap[destination.uic].name,
            searchOriginName: stationsMap[origin.uic].name,
            searchOutboundDate: (0,format["default"])(outboundDate, 'yyyy-MM-dd'),
            searchReturnDate: inboundDate ? (0,format["default"])(inboundDate, 'yyyy-MM-dd') : null
        },
        ticketProducts: {
            adultPassengers: adultPassengers,
            kidPassengers: kidPassengers,
            preferentialPassengers: preferentialPassengers,
            totalPassengers: adultPassengers + kidPassengers + preferentialPassengers
        }
    });
};

;// CONCATENATED MODULE: ./analytics/events/ticketsSearch/index.ts


// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useUpdateEffect.js + 1 modules
var useUpdateEffect = __webpack_require__(54021);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/hooks/useForm/hook.ts











function hook_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function hook_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function hook_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hook_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function hook_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function hook_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hook_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function hook_slicedToArray(arr, i) {
    return hook_arrayWithHoles(arr) || hook_iterableToArrayLimit(arr, i) || hook_unsupportedIterableToArray(arr, i) || hook_nonIterableRest();
}
function hook_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return hook_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return hook_arrayLikeToArray(o, minLen);
}
var validationSchema = es/* object */.Ry().shape({
    origin: es/* mixed */.nK().required(),
    destination: es/* mixed */.nK().required(),
    outboundDate: es/* mixed */.nK().required()
});
var hook_obj;
var defaultInitialValues = {
    origin: null,
    destination: null,
    outboundDate: null,
    inboundDate: null,
    passengers: (hook_obj = {}, hook_defineProperty(hook_obj, Passenger/* PassengerTypes.BASIC_MALE */.L.BASIC_MALE, 0), hook_defineProperty(hook_obj, Passenger/* PassengerTypes.BASIC_FEMALE */.L.BASIC_FEMALE, 0), hook_defineProperty(hook_obj, Passenger/* PassengerTypes.KID */.L.KID, 0), hook_defineProperty(hook_obj, Passenger/* PassengerTypes.KID_BABY */.L.KID_BABY, 0), hook_defineProperty(hook_obj, Passenger/* PassengerTypes.DISABLED_MALE */.L.DISABLED_MALE, 0), hook_defineProperty(hook_obj, Passenger/* PassengerTypes.DISABLED_FEMALE */.L.DISABLED_FEMALE, 0), hook_obj)
};
var getDefaultInitialValues = function() {
    return hook_objectSpread({}, defaultInitialValues, {
        passengers: hook_objectSpread({}, defaultInitialValues.passengers, hook_defineProperty({}, Passenger/* PassengerTypes.BASIC_MALE */.L.BASIC_MALE, 1))
    });
};
var buildQuery = function(values) {
    var query = {};
    var passengersString = Object.entries(values.passengers).filter(function(param) {
        var _param = hook_slicedToArray(param, 2), _ = _param[0], value = _param[1];
        return Boolean(value);
    }).map(function(param) {
        var _param = hook_slicedToArray(param, 2), key = _param[0], value = _param[1];
        return "".concat(key).concat(value);
    }).join(',');
    if (values.origin) query.origin = values.origin.shortCode;
    if (values.destination) query.destination = values.destination.shortCode;
    if (values.outboundDate) query.outbound = (0,format["default"])(values.outboundDate, 'ddMM');
    if (values.inboundDate) query.inbound = (0,format["default"])(values.inboundDate, 'ddMM');
    query.passengers = passengersString;
    return query;
};
var useForm = function() {
    var initialValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getDefaultInitialValues();
    var stations = (0,hooks/* useAppSelector */.C)((0,selector/* getEntities */.u)('stations'));
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(initialValues.passengers || defaultInitialValues.passengers), passengers = ref[0], setPassengers = ref[1];
    var onSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return router.push({
                            pathname: '/search/results',
                            query: buildQuery(values)
                        });
                    case 2:
                        /* Analytics event */ ticketsSearchEvent(stations !== null && stations !== void 0 ? stations : [], values);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: hook_objectSpread({}, defaultInitialValues, initialValues, {
            outboundDate: new Date(initialValues.outboundDate || ''),
            inboundDate: initialValues.inboundDate ? new Date(initialValues.inboundDate || '') : null
        }),
        onSubmit: onSubmit,
        validationSchema: validationSchema,
        validateOnChange: true,
        isInitialValid: Boolean(initialValues.origin && initialValues.destination && initialValues.outboundDate)
    });
    var addPassenger = function(type) {
        setPassengers(hook_objectSpread({}, passengers, hook_defineProperty({}, type, (passengers[type] || 0) + 1)));
    };
    var removePassenger = function(type) {
        if (!passengers[type]) return;
        setPassengers(hook_objectSpread({}, passengers, hook_defineProperty({}, type, (passengers[type] || 0) - 1)));
    };
    (0,useUpdateEffect/* default */.Z)(function() {
        var calculateLength = function(p) {
            return Object.values(p).reduce(function(acc, curr) {
                return acc + curr;
            }, 0);
        };
        if (calculateLength(formik.values.passengers) !== calculateLength(passengers)) void formik.setFieldValue('passengers', passengers);
    }, [
        passengers
    ]);
    return hook_objectSpread({}, formik, {
        addPassenger: addPassenger,
        removePassenger: removePassenger
    });
};

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/hooks/useForm/index.ts


// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 5 modules
var react_select_esm = __webpack_require__(79543);
// EXTERNAL MODULE: ./store/features/stations/selectors.ts
var selectors = __webpack_require__(62736);
// EXTERNAL MODULE: ./components/ui/Grid/index.ts + 9 modules
var Grid = __webpack_require__(83055);
// EXTERNAL MODULE: ./components/ui/Skeleton/index.ts + 2 modules
var Skeleton = __webpack_require__(46109);
// EXTERNAL MODULE: ./node_modules/uniqid/index.js
var uniqid = __webpack_require__(76104);
var uniqid_default = /*#__PURE__*/__webpack_require__.n(uniqid);
// EXTERNAL MODULE: ./components/ui/Button/index.ts + 2 modules
var Button = __webpack_require__(41001);
;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/Hints/styles.ts


function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  .button-typography {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    transition: all 0.2s ease;\n    font-weight: 400;\n    margin-right: 4px;\n    &:after {\n      content: ',';\n      position: absolute;\n      right: 2px;\n    }\n    &:before {\n      content: attr(title);\n      font-weight: bold;\n      visibility: hidden;\n      overflow: hidden;\n      user-select: none;\n      pointer-events: none;\n      height: 0;\n    }\n    &:hover {\n      color: ",
        ";\n    }\n\n    @media screen and (min-width: 1061px) and (max-width: 1360px) {\n      font-size: 12px;\n    }\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: calc(189px);\n\n  ",
        " {\n    max-width: calc(189px / 2);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    &:last-child {\n      .button-typography {\n        &:after {\n          display: none;\n        }\n      }\n    }\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var TextButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-84abbe73-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
});
var styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-84abbe73-1"
})(styles_templateObject1(), TextButton);

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/Hints/component.tsx







var Hints = function(param) {
    var hints = param.hints, onHintClick = param.onHintClick;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            container: true,
            children: [
                hints.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                    container: true,
                    columnGap: 6,
                    cols: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                            width: 70,
                            height: 18,
                            radius: 6
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                            width: 70,
                            height: 18,
                            radius: 6
                        })
                    ]
                }),
                hints.map(function(hint) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextButton, {
                        type: "button",
                        tabIndex: -1,
                        onClick: function() {
                            return onHintClick(hint);
                        },
                        variant: "text",
                        textColor: theme.palette.text.DEEP_GRAY,
                        children: hint
                    }, uniqid_default()());
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/Hints/index.ts


// EXTERNAL MODULE: ./node_modules/react-select/dist/Select-126cf1dd.esm.js + 4 modules
var Select_126cf1dd_esm = __webpack_require__(89570);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useDebounce.js + 1 modules
var useDebounce = __webpack_require__(35386);
;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/CitySelect/hooks/useSelect/hook.ts



function useSelect_hook_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useSelect_hook_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSelect_hook_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useSelect_hook_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useSelect_hook_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSelect_hook_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useSelect_hook_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useSelect_hook_slicedToArray(arr, i) {
    return useSelect_hook_arrayWithHoles(arr) || useSelect_hook_iterableToArrayLimit(arr, i) || useSelect_hook_unsupportedIterableToArray(arr, i) || useSelect_hook_nonIterableRest();
}
function useSelect_hook_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSelect_hook_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSelect_hook_arrayLikeToArray(o, minLen);
}
var useSelect = function(param1) {
    var stations = param1.stations, changeCallback = param1.changeCallback, exclude = param1.exclude, initial = param1.initial;
    var getInitialValue = function() {
        if (!initial) return null;
        return stations.find(function(station) {
            return station.uic === initial.uic;
        }) || null;
    };
    var ref5 = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(getInitialValue()), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react.useState)(''), inputValue = ref2[0], setInputValue = ref2[1];
    var ref3 = useSelect_hook_slicedToArray((0,useToggle/* default */.Z)(false), 2), isFocused = ref3[0], toggleFocus = ref3[1];
    var ref4 = useSelect_hook_slicedToArray((0,useToggle/* default */.Z)(false), 2), touched = ref4[0], toggleTouched = ref4[1];
    var filterOption = function(candidate, search) {
        var filter = (0,Select_126cf1dd_esm.c)();
        var isCorrect = filter(candidate, search);
        if (isCorrect) return isCorrect;
        return Boolean(candidate.data.synonyms.findIndex(function(synonym) {
            return filter(useSelect_hook_objectSpread({}, candidate, {
                label: synonym
            }), search);
        }) + 1);
    };
    var filteredStations = (0,react.useMemo)(function() {
        return stations.map(function(station) {
            return {
                label: station.name,
                value: station.uic,
                data: station
            };
        }).filter(function(option) {
            return filterOption(option, inputValue) && (exclude ? option.value !== exclude.uic : true);
        }).map(function(option) {
            return useSelect_hook_objectSpread({}, option.data);
        });
    }, [
        stations,
        filterOption,
        inputValue
    ]);
    var handleChange = function(newValue) {
        var ref;
        setValue(newValue);
        toggleTouched(false);
        changeCallback === null || changeCallback === void 0 ? void 0 : changeCallback();
        (ref = ref5.current) === null || ref === void 0 ? void 0 : ref.blur();
    };
    var handleChangeInput = function(newInputValue, param) {
        var action = param.action;
        setInputValue(newInputValue);
        if (action === 'input-change') {
            toggleTouched(true);
            if (newInputValue === '') setValue(null);
        }
    };
    var handleFocus = function() {
        toggleFocus(true);
        if (value) {
            setInputValue(value.name);
        }
    };
    var handleBlur = function() {
        toggleFocus(false);
    };
    (0,useDebounce/* default */.Z)(function() {
        if (!value && inputValue && filteredStations.length === 1) {
            handleChange(filteredStations[0]);
        }
    }, 500, [
        inputValue
    ]);
    (0,useUpdateEffect/* default */.Z)(function() {
        var found = stations.find(function(station) {
            return station.uic === (value === null || value === void 0 ? void 0 : value.uic);
        });
        if (found && found.name !== (value === null || value === void 0 ? void 0 : value.name)) setValue(found);
    }, [
        stations
    ]);
    var menuIsOpen = isFocused || Boolean(inputValue && (!value || touched));
    return {
        ref: ref5,
        value: value,
        inputValue: inputValue,
        handleChangeInput: handleChangeInput,
        isFocused: isFocused,
        toggleFocus: toggleFocus,
        handleChange: handleChange,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        menuIsOpen: menuIsOpen,
        setValue: setValue,
        filterOption: filterOption
    };
};

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/CitySelect/hooks/useSelect/index.ts


// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 7 modules
var polished_esm = __webpack_require__(95044);
// EXTERNAL MODULE: ./styles/mixins/noScrollbar/noScrollbar.ts
var noScrollbar = __webpack_require__(76389);
// EXTERNAL MODULE: ./utilities/pixelize/pixelize.ts
var pixelize = __webpack_require__(60548);
;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/CitySelect/styles.ts







function CitySelect_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CitySelect_styles_templateObject() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n  0% {\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  100% {\n    opacity: 1;\n    visibility: visible;\n  }\n"
    ]);
    CitySelect_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CitySelect_styles_templateObject1() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n          border-radius: 12px 0 0 12px;\n\n          @media screen and (max-width: 1130px) {\n            border-radius: 12px 12px 0 0;\n          }\n        "
    ]);
    CitySelect_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n          border-radius: 0 12px 12px 0;\n\n          @media screen and (max-width: 1130px) {\n            border-radius: 0 0 12px 12px;\n          }\n        "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n          border-color: ",
        ";\n        "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n            margin-bottom: 22px;\n          "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 2;\n  .search-select {\n    &__control {\n      cursor: pointer;\n      height: 50px;\n      background-color: ",
        ";\n      border: 1px solid ",
        ";\n      width: 165px;\n      ",
        "\n\n      ",
        "\n  \n      ",
        "\n\n      ",
        "\n      font-family: 'Open Sans', sans-serif;\n      min-height: auto;\n\n      &:hover {\n        background-color: ",
        ";\n        border: 1px solid ",
        ";\n        box-shadow: none;\n      }\n\n      &--is-focused {\n        .search-select__single-value,\n        .search-select__placeholder {\n          visibility: hidden;\n        }\n      }\n\n      &--is-focused,\n      &--menu-is-open {\n        border: 1px solid ",
        ";\n        box-shadow: none;\n        background-color: ",
        ";\n        &:hover {\n          border: 1px solid ",
        ";\n          box-shadow: none;\n          background-color: ",
        ";\n        }\n      }\n\n      @media screen and (max-width: 1439px) {\n        width: 180px;\n      }\n\n      @media screen and (max-width: 1390px) {\n        width: 155px;\n      }\n\n      @media screen and (max-width: 1260px) {\n        width: 140px;\n      }\n\n      @media screen and (max-width: 1225px) {\n        width: 130px;\n      }\n\n      @media screen and (max-width: 1130px) {\n        width: 100%;\n        height: 72px;\n      }\n    }\n\n    &__indicator-separator {\n      display: none;\n    }\n\n    &__value-container {\n      padding: 0;\n      transition: 0.3s;\n\n      @media screen and (max-width: 1130px) {\n        ",
        "\n      }\n    }\n\n    &__single-value {\n      visibility: visible;\n    }\n\n    &__single-value,\n    &__placeholder {\n      color: ",
        ";\n      font-size: ",
        ";\n      margin: 0;\n      line-height: 1.3;\n    }\n\n    &__input {\n      color: ",
        " !important;\n      font-size: ",
        " !important;\n      &-container {\n        margin: 0px 0 2px;\n        padding: 0;\n      }\n    }\n\n    &__dropdown-indicator {\n      display: none;\n    }\n\n    &__menu {\n      z-index: 10;\n      border: none;\n      margin: 4px 0 0;\n      width: 100%;\n      border-radius: 0 0 12px 12px;\n      box-shadow: ",
        ";\n      animation: ",
        " 0.2s ease;\n    }\n\n    &__menu-list {\n      padding-top: 16px;\n      padding-bottom: 8px;\n      ",
        "\n    }\n\n    &__option {\n      font-family: 'Open Sans', sans-serif;\n      cursor: pointer;\n      color: ",
        ";\n      font-size: ",
        ";\n\n      ",
        "\n\n      &--is-focused {\n        background-color: ",
        ";\n      }\n\n      &--is-selected {\n        color: ",
        ";\n        background-color: ",
        ";\n      }\n\n      &:active {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n      visibility: visible;\n      opacity: 1;\n    "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n        top: calc(50% - 10px);\n      "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 2;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 16px;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.3s ease;\n  ",
        "\n\n  @media screen and (max-width: 1130px) {\n    ",
        "\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  cursor: pointer;\n  z-index: 2;\n  top: ",
        "; // 13 = 26(18px height of buttons + 8px margin) / 2\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: ",
        ";\n  border-radius: 50%;\n  padding: 5px 5px 2px;\n  border: 3px solid ",
        ";\n  transition: all 0.3s ease;\n\n  &[disabled] {\n    pointer-events: none;\n  }\n\n  &:hover {\n    background-color: ",
        ";\n    .icon {\n      fill: ",
        ";\n    }\n  }\n\n  .icon {\n    transition: all 0.3s ease;\n  }\n\n  @media screen and (max-width: 1130px) {\n    top: calc(50% - 16px);\n    right: 17px;\n    left: unset;\n    background-color: ",
        ";\n    transform: rotate(90deg);\n  }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n  position: relative;\n\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n    z-index: 3;\n\n    ",
        "\n\n    ",
        "\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n  display: none;\n  width: calc(100% - 80px);\n  height: 1px;\n  background: ",
        ";\n  z-index: 2;\n  position: absolute;\n  top: 50%;\n  transform: translate(16px, -50%);\n\n  @media screen and (max-width: 1130px) {\n    display: block;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1130px) {\n    position: relative;\n\n    &:first-child {\n      border-radius: 12px 12px 0 0;\n      z-index: 2;\n    }\n\n    &:last-child {\n      border-radius: 0 0 12px 12px;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n        display: none;\n      "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1360px) {\n    margin-left: 0;\n  }\n\n  @media screen and (max-width: 1130px) {\n    margin: 0;\n    position: absolute;\n    bottom: 11px;\n    left: 39px;\n    z-index: 2;\n\n    span {\n      font-size: 12px;\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = CitySelect_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1130px) {\n    height: auto;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
var fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(CitySelect_styles_templateObject());
var SelectWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-508932fa-0"
})(styles_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.TRANSPARENT;
}, function(param) {
    var hasValue = param.hasValue;
    return (0,indent/* indent */.W)('padding', {
        top: 11,
        bottom: 10,
        left: hasValue ? 16 : 40,
        right: 16
    });
}, function(param) {
    var left = param.left;
    return left && (0,styled_components_browser_esm/* css */.iv)(CitySelect_styles_templateObject1());
}, function(param) {
    var right = param.right;
    return right && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2());
}, function(param1) {
    var focused = param1.focused;
    return focused && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.palette.secondary.MAIN;
    });
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.TRANSPARENT;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var cityIsSelected = param.cityIsSelected;
    return !cityIsSelected && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject4());
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.MAIN;
}, function(param) {
    var theme = param.theme;
    return (0,pixelize/* pixelize */.P)(theme.typography.sizes.DEFAULT);
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.MAIN;
}, function(param) {
    var theme = param.theme;
    return (0,pixelize/* pixelize */.P)(theme.typography.sizes.DEFAULT);
}, function(param) {
    var theme = param.theme;
    return theme.shadow.primary;
}, fadeIn, (0,noScrollbar/* noScrollbar */.I)(), function(param) {
    var theme = param.theme;
    return theme.palette.text.MAIN;
}, function(param) {
    var theme = param.theme;
    return (0,pixelize/* pixelize */.P)(theme.typography.sizes.DEFAULT);
}, function() {
    return (0,indent/* indent */.W)('padding', {
        vertical: 8,
        horizontal: 16
    });
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.ALTERNATIVE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.primary.MAIN;
}, function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.1, theme.palette.primary.MAIN);
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.ALTERNATIVE;
});
var SelectIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-508932fa-1"
})(styles_templateObject8(), function(param) {
    var isShow = param.isShow;
    return isShow && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject6());
}, function(param) {
    var cityIsSelected = param.cityIsSelected;
    return !cityIsSelected && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject7());
});
var SwitchButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-508932fa-2"
})(styles_templateObject9(), function(param) {
    var useHints = param.useHints;
    return "calc(50% - ".concat(useHints ? 13 : 0, "px)");
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
});
var CitySelect_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-508932fa-3"
})(_templateObject10(), function(param) {
    var cityFromSelectIsFocused = param.cityFromSelectIsFocused;
    return cityFromSelectIsFocused && "\n      z-index: 4;\n    ";
}, function(param) {
    var cityToSelectIsFocused = param.cityToSelectIsFocused;
    return cityToSelectIsFocused && "\n      z-index: 4;\n    ";
});
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-508932fa-4"
})(_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.palette.core.LIGHT_GRAY;
}, function(param) {
    var isFocused = param.isFocused;
    return isFocused && "\n    background: transparent;\n  ";
});
var SelectFlexContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-508932fa-5"
})(_templateObject12());
var HintBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* Box */.x).withConfig({
    componentId: "sc-508932fa-6"
})(_templateObject14(), function(param) {
    var cityIsSelected = param.cityIsSelected;
    return cityIsSelected && (0,styled_components_browser_esm/* css */.iv)(_templateObject13());
});
var FlexContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-508932fa-7"
})(_templateObject15());

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/CitySelect/component.tsx













var CitySelect = function(param) {
    var onSelectCities = param.onSelectCities, initialFrom = param.initialFrom, initialTo = param.initialTo, cityFrom = param.cityFrom, cityTo = param.cityTo, _useHints = param.useHints, useHints = _useHints === void 0 ? true : _useHints, _autofocus = param.autofocus, autofocus = _autofocus === void 0 ? false : _autofocus;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var t = (0,useTranslation/* default */.Z)().t;
    var stations = (0,hooks/* useAppSelector */.C)(selectors/* getSortedStations */.t);
    var cityToSelect = useSelect({
        stations: stations,
        initial: initialTo,
        exclude: cityFrom
    });
    var cityFromSelect = useSelect({
        stations: stations,
        initial: initialFrom,
        exclude: cityTo,
        changeCallback: function() {
            var ref;
            (ref = cityToSelect.ref.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    });
    (0,react.useEffect)(function() {
        onSelectCities([
            cityFromSelect.value,
            cityToSelect.value
        ]);
    }, [
        cityFromSelect.value,
        cityToSelect.value
    ]);
    var switchValues = function() {
        var fromValue = cityFromSelect.value;
        var toValue = cityToSelect.value;
        cityFromSelect.setValue(toValue);
        cityToSelect.setValue(fromValue);
        onSelectCities([
            toValue,
            fromValue
        ]);
    };
    var noOptionsMessage = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
            typography: theme.typography.variants.description.MAIN,
            color: theme.palette.text.DEEP_GRAY,
            children: t('ticketSearch:notFound')
        });
    };
    var excludedStations = stations.filter(function(station) {
        var ref;
        return station.uic !== ((ref = cityFromSelect.value) === null || ref === void 0 ? void 0 : ref.uic);
    });
    // Hardcoded popular stations UIC codes
    var stationsHints = [
        '2704600',
        '2704807',
        '2704822',
        '2704980'
    ];
    var hints = stationsHints.map(function(uic) {
        var ref;
        return (ref = excludedStations.find(function(s) {
            return s.uic === uic;
        })) === null || ref === void 0 ? void 0 : ref.name;
    }).filter(function(label) {
        return Boolean(label);
    }).slice(0, 2);
    var cityFromIsSelected = Boolean(cityFromSelect.value);
    var cityToIsSelected = Boolean(cityToSelect.value);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CitySelect_styles_Wrapper, {
        cityFromSelectIsFocused: cityFromSelect.isFocused,
        cityToSelectIsFocused: cityToSelect.isFocused,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexContainer, {
            container: true,
            height: useHints ? 'auto' : 50,
            columnGap: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectFlexContainer, {
                    container: true,
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWrapper, {
                            left: true,
                            hasValue: false,
                            cityIsSelected: cityFromIsSelected,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectIconWrapper, {
                                    isShow: true,
                                    cityIsSelected: cityFromIsSelected,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: theme.icons.core.Pin,
                                        color: theme.palette.secondary.MAIN
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                    autoFocus: autofocus,
                                    blurInputOnSelect: true,
                                    ref: cityFromSelect.ref,
                                    inputValue: cityFromSelect.inputValue,
                                    onInputChange: cityFromSelect.handleChangeInput,
                                    onFocus: cityFromSelect.handleFocus,
                                    onBlur: cityFromSelect.handleBlur,
                                    onChange: cityFromSelect.handleChange,
                                    value: cityFromSelect.value,
                                    menuIsOpen: cityFromSelect.menuIsOpen,
                                    filterOption: cityFromSelect.filterOption,
                                    options: stations,
                                    getOptionLabel: function(option) {
                                        return option.name;
                                    },
                                    getOptionValue: function(option) {
                                        return option.uic;
                                    },
                                    noOptionsMessage: noOptionsMessage,
                                    placeholder: t('ticketSearch:from'),
                                    instanceId: "city-select-from",
                                    classNamePrefix: "search-select",
                                    inputId: "city-select-input-from"
                                })
                            ]
                        }),
                        useHints && /*#__PURE__*/ (0,jsx_runtime.jsx)(HintBox, {
                            marginTop: 6,
                            marginLeft: 8,
                            cityIsSelected: cityFromIsSelected,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hints, {
                                hints: hints,
                                onHintClick: function(hint) {
                                    var found = excludedStations.find(function(station) {
                                        return station.name === hint;
                                    });
                                    cityFromSelect.handleChange(found);
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                    isFocused: cityFromSelect.isFocused || cityToSelect.isFocused
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                    type: "button",
                    tabIndex: -1,
                    onClick: switchValues,
                    disabled: !cityFromSelect.value && !cityToSelect.value,
                    "data-testid": "switch",
                    useHints: useHints,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        icon: theme.icons.core.SwitchArrow,
                        color: theme.palette.core.DEEP_GRAY
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectFlexContainer, {
                    container: true,
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWrapper, {
                            right: true,
                            hasValue: false,
                            cityIsSelected: cityToIsSelected,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectIconWrapper, {
                                    isShow: true,
                                    cityIsSelected: cityToIsSelected,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: theme.icons.core.Pin,
                                        color: theme.palette.secondary.MAIN
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                    blurInputOnSelect: true,
                                    ref: cityToSelect.ref,
                                    inputValue: cityToSelect.inputValue,
                                    onInputChange: cityToSelect.handleChangeInput,
                                    onFocus: cityToSelect.handleFocus,
                                    onBlur: cityToSelect.handleBlur,
                                    onChange: cityToSelect.handleChange,
                                    value: cityToSelect.value,
                                    menuIsOpen: cityToSelect.menuIsOpen,
                                    filterOption: cityToSelect.filterOption,
                                    options: excludedStations,
                                    getOptionLabel: function(option) {
                                        return option.name;
                                    },
                                    getOptionValue: function(option) {
                                        return option.uic;
                                    },
                                    noOptionsMessage: noOptionsMessage,
                                    placeholder: t('ticketSearch:to'),
                                    instanceId: "city-select-to",
                                    classNamePrefix: "search-select",
                                    inputId: "city-select-input-to"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HintBox, {
                            marginTop: 6,
                            marginLeft: 8,
                            cityIsSelected: cityToIsSelected,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                container: true,
                                columnGap: 2,
                                children: useHints && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hints, {
                                    hints: hints,
                                    onHintClick: function(hint) {
                                        var found = excludedStations.find(function(station) {
                                            return station.name === hint;
                                        });
                                        cityToSelect.handleChange(found);
                                    }
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/CitySelect/index.ts


// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(18698);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js
var useWindowSize = __webpack_require__(98504);
// EXTERNAL MODULE: ./utilities/format/index.ts + 4 modules
var utilities_format = __webpack_require__(42558);
// EXTERNAL MODULE: ./utilities/getLocale/index.ts + 16 modules
var getLocale = __webpack_require__(79830);
;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/Datepicker/styles.ts






function Datepicker_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Datepicker_styles_templateObject() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n  position: relative;\n\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n  }\n"
    ]);
    Datepicker_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Datepicker_styles_templateObject1() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n      border-top-left-radius: 12px;\n      border-bottom-left-radius: 12px;\n    "
    ]);
    Datepicker_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Datepicker_styles_templateObject2() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n      border-top-right-radius: 12px;\n      border-bottom-right-radius: 12px;\n    "
    ]);
    Datepicker_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Datepicker_styles_templateObject3() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    Datepicker_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Datepicker_styles_templateObject4() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  width: 170px;\n  height: 50px;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n  \n  span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n\n  @media screen and (max-width: 1360px) {\n    padding: 16px;\n  }\n\n  @media screen and (max-width: 1330px) {\n    width: 140px;\n  }\n\n  @media screen and (max-width: 1225px) {\n    width: 130px;\n  }\n\n  @media screen and (max-width: 1150px) {\n    width: 120px;\n  }\n\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n    padding: 16px 32px 16px 16px;\n  }\n\n  @media screen and (max-width: 390px) {\n    > div {\n      width: 95px;\n    }\n  }\n\n  @media screen and (max-width: 360px) {\n    > div {\n      width: 75px;\n    }\n  }\n"
    ]);
    Datepicker_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Datepicker_styles_templateObject5() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n      visibility: visible;\n      opacity: 1;\n    "
    ]);
    Datepicker_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Datepicker_styles_templateObject6() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  background-color: ",
        ";\n  border-radius: 12px;\n  width: 635px;\n  position: absolute;\n  top: calc(100% + 8px);\n  left: calc(-317.5px / 2);\n\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.2s ease;\n  ",
        "\n\n  .react-datepicker {\n    border: none;\n    background: none;\n    display: flex;\n    column-gap: 25px;\n    &__navigation {\n      top: 0;\n      z-index: 10;\n\n      &-icon {\n        &:before {\n          border-color: ",
        ";\n          transition: all 0.2s ease;\n        }\n        &:hover {\n          &:before {\n            border-color: ",
        ";\n          }\n        }\n      }\n\n      &--previous {\n        left: 0;\n      }\n      &--next {\n        right: 0;\n      }\n    }\n    &__header {\n      border: none;\n      background: none;\n      padding: 0;\n    }\n    &__current-month {\n      color: ",
        ";\n      text-transform: capitalize;\n      margin-bottom: 16px;\n      font-size: 16px;\n      margin-top: 8px;\n    }\n\n    &__day-name {\n      text-transform: capitalize;\n      font-size: 14px;\n      color: ",
        ";\n      width: 40px;\n      height: 40px;\n      margin: 0 0 12px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n    &__month {\n      margin: 0;\n    }\n    &__week {\n      display: flex;\n    }\n    &__day {\n      flex-grow: 1;\n      text-transform: capitalize;\n      font-size: 14px;\n      color: ",
        ";\n      background-color: ",
        ";\n      border-color: ",
        ";\n      border-width: 1px;\n      border-style: solid;\n      width: 40px;\n      height: 40px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      margin: 0 -1px -1px 0; // hack for prevent double borders\n      &:hover {\n        background-color: ",
        ";\n        color: ",
        ";\n        border-radius: 0;\n      }\n      &--in-range,\n      &--in-selecting-range {\n        background-color: ",
        ";\n        border-radius: 0;\n      }\n      &--in-selecting-range {\n        background-color: ",
        ";\n      }\n      &--selected,\n      &--range-start,\n      &--range-end {\n        background-color: ",
        ";\n        color: ",
        ";\n        border-radius: 0;\n      }\n      &--outside-month {\n        display: block;\n        opacity: 0;\n        pointer-events: none;\n      }\n      &--disabled {\n        pointer-events: none;\n        background-color: ",
        ";\n      }\n    }\n\n    @media screen and (max-width: 780px) {\n      flex-direction: column;\n\n      &__day-name {\n        width: 14%; // 100% / 7 = 14%\n        height: 35px;\n        margin-bottom: 16px;\n      }\n\n      .react-datepicker {\n        &__navigation {\n          &--previous {\n            left: -9px;\n          }\n          &--next {\n            right: -9px;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 1130px) {\n    left: 50%;\n    transform: translateX(-50%);\n    top: 100%;\n  }\n\n  @media screen and (max-width: 780px) {\n    width: ",
        ";\n    top: -77px;\n    padding: 16px;\n    box-shadow: 0px 0px 20px 8px rgba(0, 0, 0, 0.11);\n  }\n"
    ]);
    Datepicker_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Datepicker_styles_templateObject7() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1130px) {\n    display: grid;\n    grid-template-columns: repeat(2, calc(50% - 2px));\n  }\n"
    ]);
    Datepicker_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Datepicker_styles_templateObject8() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 780px) {\n    display: none;\n  }\n"
    ]);
    Datepicker_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Datepicker_styles_templateObject9() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 780px) {\n    width: 100%;\n    margin-top: 16px;\n  }\n\n  @media screen and (max-width: 330px) {\n    padding: 8.5px 20px;\n  }\n"
    ]);
    Datepicker_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 780px) {\n    padding-bottom: 4px;\n  }\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = Datepicker_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1360px) {\n    margin-left: 0;\n  }\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
var Datepicker_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3dc9275f-0"
})(Datepicker_styles_templateObject());
var DatepickerButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3dc9275f-1"
})(Datepicker_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.TRANSPARENT;
}, function() {
    return (0,indent/* indent */.W)('padding', {
        top: 14,
        bottom: 16,
        left: 16,
        right: 32
    });
}, function(param) {
    var left = param.left;
    return left && (0,styled_components_browser_esm/* css */.iv)(Datepicker_styles_templateObject1());
}, function(param) {
    var right = param.right;
    return right && (0,styled_components_browser_esm/* css */.iv)(Datepicker_styles_templateObject2());
}, function(param1) {
    var focused = param1.focused;
    return focused && (0,styled_components_browser_esm/* css */.iv)(Datepicker_styles_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.palette.secondary.MAIN;
    }, function(param) {
        var theme = param.theme;
        return theme.palette.core.WHITE;
    });
});
var DatepickerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3dc9275f-2"
})(Datepicker_styles_templateObject6(), (0,indent/* indent */.W)('padding', {
    vertical: 20,
    horizontal: 24
}), function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var isShow = param.isShow;
    return isShow && (0,styled_components_browser_esm/* css */.iv)(Datepicker_styles_templateObject5());
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.BLACK;
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.DEEP_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.DEEP_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.2, theme.palette.secondary.MAIN);
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.ALTERNATIVE;
}, function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.secondary.MAIN);
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.TRANSPARENT;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.ALTERNATIVE;
}, function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.7, theme.palette.core.LIGHT_GRAY);
}, function(param) {
    var isHomeScreen = param.isHomeScreen;
    return isHomeScreen ? 'calc(100% + 32px)' : '100%';
});
var DatepickerButtonContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-3dc9275f-3"
})(Datepicker_styles_templateObject7());
var DesktopButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-3dc9275f-4"
})(Datepicker_styles_templateObject8());
var MobileButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-3dc9275f-5"
})(Datepicker_styles_templateObject9());
var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* Box */.x).withConfig({
    componentId: "sc-3dc9275f-6"
})(styles_templateObject10());
var styles_HintBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* Box */.x).withConfig({
    componentId: "sc-3dc9275f-7"
})(styles_templateObject11());

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/Datepicker/component.tsx


















function component_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function component_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function component_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function component_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function component_slicedToArray(arr, i) {
    return component_arrayWithHoles(arr) || component_iterableToArrayLimit(arr, i) || component_unsupportedIterableToArray(arr, i) || component_nonIterableRest();
}
function component_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return component_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return component_arrayLikeToArray(o, minLen);
}
var DATEPICKER_FORMAT = 'd MMMM, EEEEEE';
var Datepicker = function(param) {
    var onSelectDates = param.onSelectDates, _focus = param.focus, focus = _focus === void 0 ? false : _focus, initialFrom = param.initialFrom, initialTo = param.initialTo, _useHints = param.useHints, useHints = _useHints === void 0 ? true : _useHints, _isHomeScreen = param.isHomeScreen, isHomeScreen = _isHomeScreen === void 0 ? true : _isHomeScreen, clearFocus = param.clearFocus;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var ref = (0,useTranslation/* default */.Z)('datepicker'), t = ref.t, lang = ref.lang;
    var width = (0,useWindowSize/* default */.Z)().width;
    var ref1 = (0,react.useState)(initialFrom || null), startDate = ref1[0], setStartDate = ref1[1];
    var ref2 = (0,react.useState)(initialTo || null), endDate = ref2[0], setEndDate = ref2[1];
    var ref3 = (0,react.useState)(null), focused = ref3[0], setFocused = ref3[1];
    var focusStart = function() {
        setStartDate(null);
        setEndDate(null);
        setFocused('start');
    };
    var focusEnd = function() {
        setEndDate(null);
        setFocused('end');
    };
    (0,react.useEffect)(function() {
        if (focus && !focused) {
            focusStart();
            clearFocus === null || clearFocus === void 0 ? void 0 : clearFocus();
        }
    }, [
        focus,
        clearFocus,
        focused
    ]);
    (0,react.useEffect)(function() {
        if (focused === 'end' && !startDate) setStartDate(new Date());
    }, [
        focused,
        startDate,
        setStartDate
    ]);
    (0,react.useEffect)(function() {
        onSelectDates([
            startDate,
            endDate
        ]);
    }, [
        startDate,
        endDate
    ]);
    var blurAll = function() {
        setFocused(null);
    };
    var handleDatesChange = function(dates) {
        var _dates = component_slicedToArray(dates, 2), start = _dates[0], end = _dates[1];
        setStartDate(start);
        setEndDate(end);
        if (start && !end) focusEnd();
        if (start && end) blurAll();
    };
    var disableReturnTicket = function() {
        setEndDate(null);
        blurAll();
    };
    var today = new Date();
    var tomorrow = (0,addDays["default"])(today, 1);
    var startDateHints = (0,react.useMemo)(function() {
        return [
            (0,utilities_format/* format */.W)(today, 'd MMMM', lang),
            (0,utilities_format/* format */.W)(tomorrow, 'd MMMM', lang)
        ];
    }, [
        lang
    ]);
    var isFocusedStart = focused === 'start';
    var isFocusedEnd = focused === 'end';
    var isShowDatepicker = isFocusedStart || isFocusedEnd;
    var isMobile = width <= 780;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_outside_click_handler["default"], {
        onOutsideClick: blurAll,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Datepicker_styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    container: true,
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DatepickerButtonContainer, {
                            container: true,
                            columnGap: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                    container: true,
                                    direction: "column",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatepickerButton, {
                                        type: "button",
                                        "data-testid": "datepicker-button",
                                        focused: isFocusedStart,
                                        left: true,
                                        onFocus: focusStart,
                                        onClick: focusStart,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            container: true,
                                            columnGap: 8,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                    icon: theme.icons.core.Calendar,
                                                    color: theme.palette.secondary.MAIN
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    typography: theme.typography.variants.content.MAIN,
                                                    children: startDate ? (0,utilities_format/* format */.W)(startDate, DATEPICKER_FORMAT, lang) : t('outbound')
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                    container: true,
                                    direction: "column",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatepickerButton, {
                                        type: "button",
                                        "data-testid": "datepicker-button",
                                        focused: isFocusedEnd,
                                        right: true,
                                        onClick: focusEnd,
                                        onFocus: focusEnd,
                                        onBlur: blurAll,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            container: true,
                                            columnGap: 8,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                    icon: theme.icons.core.Calendar,
                                                    color: theme.palette.secondary.MAIN
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    typography: theme.typography.variants.content.MAIN,
                                                    children: endDate ? (0,utilities_format/* format */.W)(endDate, DATEPICKER_FORMAT, lang) : t('inbound')
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        useHints && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_HintBox, {
                            marginTop: 6,
                            marginLeft: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hints, {
                                hints: startDateHints,
                                onHintClick: function(hint) {
                                    var date = hint === (0,utilities_format/* format */.W)(today, 'd MMMM', lang) ? today : tomorrow;
                                    handleDatesChange([
                                        date,
                                        endDate
                                    ]);
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DatepickerWrapper, {
                    isShow: isShowDatepicker,
                    isHomeScreen: isHomeScreen,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            container: true,
                            justify: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBox, {
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                        typography: theme.typography.variants.content.BOLD,
                                        color: theme.palette.text.DEEP_GRAY,
                                        children: [
                                            t('pick'),
                                            " ",
                                            t(isFocusedStart ? 'departure' : 'return'),
                                            " "
                                        ]
                                    })
                                }),
                                isFocusedEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopButton, {
                                    variant: "flat",
                                    fill: "outlined",
                                    onClick: disableReturnTicket,
                                    children: t('returnTicket')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            marginTop: 16,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                selected: startDate,
                                onChange: handleDatesChange,
                                startDate: startDate,
                                endDate: endDate,
                                selectsRange: true,
                                monthsShown: isMobile ? 1 : 2,
                                locale: (0,getLocale/* getLocale */.K)(lang),
                                inline: true,
                                minDate: new Date(),
                                maxDate: (0,addDays["default"])(new Date(), env/* SALES_DEPTH_LIMIT */.dG)
                            })
                        }),
                        isFocusedEnd && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileButton, {
                            variant: "flat",
                            fill: "outlined",
                            onClick: disableReturnTicket,
                            children: t('returnTicket')
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/libs/Datepicker/index.ts


;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/styles.ts



function SearchTicketsForm_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchTicketsForm_styles_templateObject() {
    var data = SearchTicketsForm_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1130px) {\n    .submit-button {\n      width: 100%;\n    }\n  }\n"
    ]);
    SearchTicketsForm_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchTicketsForm_styles_templateObject1() {
    var data = SearchTicketsForm_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n    flex-direction: column;\n  }\n"
    ]);
    SearchTicketsForm_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchTicketsForm_styles_templateObject2() {
    var data = SearchTicketsForm_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n    flex-direction: column;\n    z-index: 2;\n\n    & > div {\n      // its hack emulate row-gap, Safari iOS(14 or later) does not support flexbox row-gap\n      margin-bottom: 4px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n"
    ]);
    SearchTicketsForm_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchTicketsForm_styles_templateObject3() {
    var data = SearchTicketsForm_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n    z-index: 3;\n  }\n"
    ]);
    SearchTicketsForm_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchTicketsForm_styles_templateObject4() {
    var data = SearchTicketsForm_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n  }\n"
    ]);
    SearchTicketsForm_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchTicketsForm_styles_templateObject5() {
    var data = SearchTicketsForm_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1190px) {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  @media screen and (max-width: 1130px) {\n    width: 100%;\n    margin-top: 16px;\n  }\n"
    ]);
    SearchTicketsForm_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var SearchTicketsForm_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e374d3a7-0"
})(SearchTicketsForm_styles_templateObject());
var styles_FlexContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-e374d3a7-1"
})(SearchTicketsForm_styles_templateObject1());
var StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-e374d3a7-2"
})(SearchTicketsForm_styles_templateObject2());
var DatepickerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e374d3a7-3"
})(SearchTicketsForm_styles_templateObject3());
var PassengersSelectContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e374d3a7-4"
})(SearchTicketsForm_styles_templateObject4());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-e374d3a7-5"
})(SearchTicketsForm_styles_templateObject5());

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/component.tsx














function SearchTicketsForm_component_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SearchTicketsForm_component_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function component_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SearchTicketsForm_component_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SearchTicketsForm_component_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SearchTicketsForm_component_slicedToArray(arr, i) {
    return SearchTicketsForm_component_arrayWithHoles(arr) || SearchTicketsForm_component_iterableToArrayLimit(arr, i) || SearchTicketsForm_component_unsupportedIterableToArray(arr, i) || SearchTicketsForm_component_nonIterableRest();
}
function SearchTicketsForm_component_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SearchTicketsForm_component_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SearchTicketsForm_component_arrayLikeToArray(o, minLen);
}
var SearchTicketsForm = function(param1) {
    var _useHints = param1.useHints, useHints = _useHints === void 0 ? true : _useHints, _autofocus = param1.autofocus, autofocus = _autofocus === void 0 ? false : _autofocus, _isHomeScreen = param1.isHomeScreen, isHomeScreen = _isHomeScreen === void 0 ? true : _isHomeScreen, rawInitialValues = param1.initialValues;
    var t = (0,useTranslation/* default */.Z)('ticketSearch').t;
    var router = (0,next_router.useRouter)();
    var ref1 = SearchTicketsForm_component_slicedToArray((0,useToggle/* default */.Z)(false), 2), focusOnDatepicker = ref1[0], toggleFocus = ref1[1];
    var stations = (0,hooks/* useAppSelector */.C)((0,selector/* getEntities */.u)('stations'));
    var initialValues = (0,react.useMemo)(function() {
        if (rawInitialValues) return rawInitialValues;
        return router.query.outbound ? getInitialSearchValues(router.query, stations) : getDefaultInitialValues();
    }, [
        router
    ]);
    var formik = useForm(initialValues);
    var handleSelectCities = function() {
        var _ref = component_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var _param, from, to, ref, setFieldValue, values;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _param = SearchTicketsForm_component_slicedToArray(param, 2), from = _param[0], to = _param[1];
                        ;
                        setFieldValue = formik.setFieldValue, values = formik.values;
                        if (to && to.uic !== ((ref = values.destination) === null || ref === void 0 ? void 0 : ref.uic)) toggleFocus(true);
                        _ctx.next = 6;
                        return setFieldValue('origin', from || null);
                    case 6:
                        _ctx.next = 8;
                        return setFieldValue('destination', to || null);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelectCities(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSelectDates = function() {
        var _ref = component_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var _param, from, to, setFieldValue;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _param = SearchTicketsForm_component_slicedToArray(param, 2), from = _param[0], to = _param[1];
                        setFieldValue = formik.setFieldValue;
                        _ctx.next = 4;
                        return setFieldValue('outboundDate', from);
                    case 4:
                        _ctx.next = 6;
                        return setFieldValue('inboundDate', to);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelectDates(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTicketsForm_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            onSubmit: formik.handleSubmit,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_FlexContainer, {
                container: true,
                justify: "space-between",
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlex, {
                        item: true,
                        grow: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlex, {
                            container: true,
                            alignItems: "flex-start",
                            columnGap: 8,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CitySelect, {
                                    cityFrom: formik.values.origin,
                                    cityTo: formik.values.destination,
                                    initialFrom: initialValues.origin,
                                    initialTo: initialValues.destination,
                                    onSelectCities: handleSelectCities,
                                    useHints: useHints,
                                    autofocus: autofocus
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DatepickerContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Datepicker, {
                                        initialFrom: initialValues.outboundDate ? new Date(initialValues.outboundDate) : null,
                                        initialTo: initialValues.inboundDate ? new Date(initialValues.inboundDate) : null,
                                        focus: focusOnDatepicker,
                                        clearFocus: function() {
                                            return toggleFocus(false);
                                        },
                                        onSelectDates: handleSelectDates,
                                        useHints: useHints,
                                        isHomeScreen: isHomeScreen
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PassengersSelectContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PassengersSelect, {
                                        passengers: formik.values.passengers,
                                        addPassenger: formik.addPassenger,
                                        removePassenger: formik.removePassenger
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        isLoading: formik.isSubmitting,
                        type: "submit",
                        disabled: !formik.isValid,
                        children: t('find')
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/shared/SearchTicketsForm/index.ts



/***/ }),

/***/ 46109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./utilities/isNumber/isNumber.ts
var isNumber = __webpack_require__(15605);
// EXTERNAL MODULE: ./utilities/pixelize/pixelize.ts
var pixelize = __webpack_require__(60548);
;// CONCATENATED MODULE: ./components/ui/Skeleton/styles.ts



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from { background-position: -200px 0 }\n  to { background-position: calc(200px + 100%) 0 }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  background-image: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0),\n    ",
        ",\n    rgba(255, 255, 255, 0)\n  );\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  user-select: none;\n  position: relative;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  ",
        "\n  ",
        "\n  animation: ",
        " 1.5s infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var shineAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var shineBase = (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
var shineGradient = function(mainColor) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), mainColor);
};
var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-309e011c-0"
})(_templateObject3(), function(param) {
    var _width = param.width, width = _width === void 0 ? '100%' : _width;
    return (0,isNumber/* isNumber */.h)(width) ? (0,pixelize/* pixelize */.P)(width) : width;
}, function(param) {
    var _height = param.height, height = _height === void 0 ? '100%' : _height;
    return (0,isNumber/* isNumber */.h)(height) ? (0,pixelize/* pixelize */.P)(height) : height;
}, function(param) {
    var _radius = param.radius, radius = _radius === void 0 ? 16 : _radius;
    return (0,isNumber/* isNumber */.h)(radius) ? (0,pixelize/* pixelize */.P)(radius) : radius;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, shineBase, function() {
    return shineGradient('#EEE9E9');
}, shineAnimation);

;// CONCATENATED MODULE: ./components/ui/Skeleton/component.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Skeleton = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Wrapper, _objectSpread({}, props, {
        children: "‌"
    }));
};

;// CONCATENATED MODULE: ./components/ui/Skeleton/index.ts



/***/ }),

/***/ 7082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* reexport */ Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-popper-tooltip/dist/styles.css
var styles = __webpack_require__(23096);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-popper-tooltip/dist/esm/react-popper-tooltip.js
var react_popper_tooltip = __webpack_require__(49768);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 7 modules
var polished_esm = __webpack_require__(95044);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
;// CONCATENATED MODULE: ./components/ui/Tooltip/styles.ts


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  } to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  background-color: ",
        ";\n  padding: 4px 8px;\n  z-index: 1001;\n  color: ",
        ";\n  font-size: 14px;\n  font-family: 'Open Sans', sans-serif;\n  backdrop-filter: blur(3px);\n  border-radius: 4px;\n  text-align: center;\n  max-width: ",
        ";\n  animation ",
        " 0.25s linear;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  --tooltipBackground: ",
        ";\n  --tooltipBorder: transparent;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var Popper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4abc46f7-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.2, theme.palette.primary.MAIN);
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.ALTERNATIVE;
}, function(param) {
    var width = param.width;
    return width ? "".concat(typeof width === 'number' ? "".concat(width, "px") : width) : 'auto';
}, fadeIn);
var Arrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4abc46f7-1"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.25, theme.palette.primary.MAIN);
});

;// CONCATENATED MODULE: ./components/ui/Tooltip/component.tsx





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Tooltip = function(_param) {
    var children = _param.children, content = _param.content, width = _param.width, config = _objectWithoutProperties(_param, [
        "children",
        "content",
        "width"
    ]);
    var ref = (0,react_popper_tooltip/* usePopperTooltip */.O)(_objectSpread({
        placement: 'top',
        trigger: 'hover',
        offset: [
            0,
            8
        ]
    }, config)), getArrowProps = ref.getArrowProps, getTooltipProps = ref.getTooltipProps, setTooltipRef = ref.setTooltipRef, setTriggerRef = ref.setTriggerRef, visible = ref.visible;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-testid": "tooltip-trigger",
                ref: function(el) {
                    return setTriggerRef(el);
                },
                children: children
            }),
            visible && document.body && /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Popper, _objectSpread({
                width: width,
                ref: function(el) {
                    return setTooltipRef(el);
                }
            }, getTooltipProps({
                className: 'tooltip-container'
            }), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, _objectSpread({}, getArrowProps({
                        className: 'tooltip-arrow'
                    }))),
                    content
                ]
            })), document.body)
        ]
    }));
};


;// CONCATENATED MODULE: ./components/ui/Tooltip/index.ts



/***/ }),

/***/ 62736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getStations; },
/* harmony export */   "t": function() { return /* binding */ getSortedStations; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var getStations = function(state) {
    return state.stations.entities;
};
var getSortedStations = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(getStations, function(stations) {
    /*
   * Spread operator is used for avoid mutating original array using sort method
   * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort}
   * {@link https://stackoverflow.com/questions/9592740/how-can-you-sort-an-array-without-mutating-the-original-array}
   * */ return _toConsumableArray(stations).sort(function(stationA, stationB) {
        if (stationA.name < stationB.name) return -1;
        if (stationA.name > stationB.name) return 1;
        return 0;
    });
});


/***/ }),

/***/ 62479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ getEntities; }
/* harmony export */ });
var getEntities = function(reducerName) {
    return function(state) {
        var reducerState = state[reducerName];
        if ('entities' in reducerState) return reducerState.entities;
        throw new Error("entities key is not available in the ".concat(reducerName, " reducer"));
    };
};


/***/ }),

/***/ 76389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ noScrollbar; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50445);

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var noScrollbar = function() {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject());
};


/***/ })

}]);